import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_REGION, EDIT_REGION, CREATE_REGION } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteRegion(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_REGION}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editRegion(prevData, searchParams, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_REGION}`, {
    id: prevData?.id,
    title: prevData?.title,
    cityId: searchParams.get("cityId")
  }, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createRegion(prevData, searchParams, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_REGION}`, {
    title: prevData?.title,
    cityId: searchParams.get("cityId")
  }, configReq(token));
}
